import mapboxgl, { Map, ScaleControl } from "mapbox-gl";

import { mapboxStyleURL } from "./config";

import { MapStepTable } from "./types";
import { mapboxToken } from "./config";

export function makeMap(container: string, mapSteps: MapStepTable): Map {
  const { center, zoom } = mapSteps["0"];

  // this is our mapbox key
  mapboxgl.accessToken = mapboxToken;

  const map = new mapboxgl.Map({
    container,
    style: mapboxStyleURL,
    center,
    zoom,
    interactive: false,
    bearing: 0
  });

  map.addControl(
    new ScaleControl({
      unit: "imperial"
    })
  );

  return map;
}
